import React, { useEffect, useState } from 'react'
import { toastError, toastSuccess } from '../../utils'
import { Grid, Box, Button, Paper, TextField, InputLabel, Tabs, Tab, Typography } from "@mui/material"
import SaveIcon from '@mui/icons-material/Save';
import * as actions from "./actions"
import CustomAddModal from '../Common/CustomAddModal';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`information-tabpanel-${index}`}
            aria-labelledby={`information-tab-${index}`}
            {...other}
        >
            {value === index && <Box pt={1}>{children}</Box>}
        </div>
    );
}

export default function Information(props) {
    const [tabValue, setTabValue] = useState(0);

    // News State
    const [news, setNews] = useState([])
    const [addNewsModel, setAddNewsModel] = useState(false);
    const [addNews, setAddNews] = useState({
        news_heading: '',
        news_link: ''
    })

    // Videos State
    const [videoLinks, setVideoLinks] = useState([])

    useEffect(() => {
        onGetNews();
        onGetVideoLinks();
    }, [])

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    // News Functions
    const onGetNews = () => {
        props.setLoader(true)
        actions.getNews().then(res => {
            props.setLoader(false)
            setNews(res.body)
        }).catch(err => {
            props.setLoader(false)
            toastError(err.message)
        })
    }

    const onClickAddNews = () => {
        setAddNewsModel(true)
    }

    const onSubmitNewsLink = () => {
        if (!addNews.news_heading && !addNews.news_link) {
            return toastError('All fields are required.')
        }
        props.setLoader(true)
        actions.addNews(addNews).then(res => {
            props.setLoader(false)
            onGetNews();
            setAddNewsModel(false)
            setAddNews({ news_heading: '', news_link: '' })
            toastSuccess(res.message)
        }).catch(err => {
            props.setLoader(false)
            toastError(err.message)
        })
    }

    // Video Functions
    const onGetVideoLinks = () => {
        actions.getVideoLinks().then(res => {
            setVideoLinks(res.body)
        }).catch(err => toastError(err.message))
    }

    const onChangeHandler = (value, index) => {
        let newVideoLinks = [...videoLinks]
        newVideoLinks[index].video_link = value;
        setVideoLinks(newVideoLinks)
    }

    const onVideoLinkUpdate = (data) => {
        actions.updateHomepageVideo(data).then(res => {
            toastSuccess(res.message)
        }).catch(err => {
            toastError(err.message)
        })
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                    <Tabs value={tabValue} onChange={handleTabChange} aria-label="information tabs">
                        <Tab label="News" />
                        <Tab label="Videos" />
                    </Tabs>
                </Box>
            </Grid>

            {/* News Tab */}
            <TabPanel value={tabValue} index={0}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => onClickAddNews()}
                            style={{ textTransform: 'capitalize' }}
                        >
                            + Add News
                        </Button>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container spacing={3}>
                            {news.length ? news.map((item, key) => {
                                return (
                                    <Grid item xs={12} key={key}>
                                        <Paper elevation={2}>
                                            <Box p={3}>
                                                <Typography variant="h6" style={{ marginBottom: 16, fontWeight: 600, color: '#333' }}>
                                                    News {key + 1}
                                                </Typography>
                                                <Box mb={1.5}>
                                                    <Typography variant="body2" style={{ fontWeight: 600, color: '#666', marginBottom: 4 }}>
                                                        Title:
                                                    </Typography>
                                                    <Typography variant="body1" style={{ color: '#333' }}>
                                                        {item.news_heading}
                                                    </Typography>
                                                </Box>
                                                <Box>
                                                    <Typography variant="body2" style={{ fontWeight: 600, color: '#666', marginBottom: 4 }}>
                                                        Link:
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        <a
                                                            href={item.news_link}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            style={{ color: '#1976d2', textDecoration: 'none' }}
                                                        >
                                                            {item.news_link}
                                                        </a>
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                )
                            }) : (
                                <Grid item xs={12}>
                                    <Box textAlign="center" py={5}>
                                        <Typography variant="body1" color="textSecondary">
                                            No news items available. Click "Add News" to create one.
                                        </Typography>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </TabPanel>

            {/* Videos Tab */}
            <TabPanel value={tabValue} index={1}>
                <Grid container spacing={3}>
                    {videoLinks.length ? videoLinks.map((video, key) => (
                        <Grid item xs={12} sm={12} md={8} lg={6} key={key}>
                            <Paper elevation={2}>
                                <Box p={3}>
                                    <Typography variant="h6" style={{ marginBottom: 20, fontWeight: 600, color: '#333' }}>
                                        Video {key + 1}
                                    </Typography>
                                    <TextField
                                        id={`video-${key}`}
                                        placeholder={`Enter Video ${key + 1} link`}
                                        variant="outlined"
                                        fullWidth
                                        value={video.video_link}
                                        onChange={e => onChangeHandler(e.target.value, key)}
                                        style={{ marginBottom: 20 }}
                                    />
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="medium"
                                        startIcon={<SaveIcon />}
                                        onClick={() => onVideoLinkUpdate({ video_id: video.video_id, video_link: video.video_link })}
                                        style={{ textTransform: 'capitalize' }}
                                    >
                                        Save
                                    </Button>
                                </Box>
                            </Paper>
                        </Grid>
                    )) : (
                        <Grid item xs={12}>
                            <Box textAlign="center" py={5}>
                                <Typography variant="body1" color="textSecondary">
                                    No video links available.
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </TabPanel>

            {/* Add News Modal */}
            <CustomAddModal
                open={addNewsModel}
                title="Add News"
                onSubmitConfirm={onSubmitNewsLink}
                handleClose={() => {
                    setAddNewsModel(false)
                    setAddNews({ news_heading: '', news_link: '' })
                }}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <InputLabel classes={{ root: 'label-tag' }}>Title</InputLabel>
                        <TextField
                            variant="outlined"
                            fullWidth
                            placeholder="Title"
                            value={addNews.news_heading}
                            onChange={e => setAddNews({ ...addNews, news_heading: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel classes={{ root: 'label-tag' }}>Link</InputLabel>
                        <TextField
                            variant="outlined"
                            fullWidth
                            placeholder="Link"
                            value={addNews.news_link}
                            onChange={e => setAddNews({ ...addNews, news_link: e.target.value })}
                        />
                    </Grid>
                </Grid>
            </CustomAddModal>
        </Grid>
    )
}
